export default __webpack_public_path__ + "static/paul@2x-829acc177b9dc78461265135097486ce.jpg";